
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { toODataString } from '@progress/kendo-data-query';
import { Observable ,  BehaviorSubject } from 'rxjs';

import DateTime from 'typescript-dotnet-es6/System/Time/DateTime'

import { RIAHelper } from './ria-helper'
import { EmailMessages,EmailAuditPackages } from './models/email-audit-packages'
import { environment } from '../../environments/environment'
import { notification_template } from './models/notification_template-model'
import { FailedPassedEmailPackage, MsgResult } from '../core'


@Injectable()
export abstract class RISDomainService extends BehaviorSubject<GridDataResult> {
  private RIABASE_URL: string = environment.baseWebApiUrl + 'api/RIA/';
  private BASE_URL_API: string = environment.baseWebApiUrl + 'api/AuditStd/';
  private BASE_URL_REVIEW_NOTIF_API: string = environment.baseWebApiUrl + 'api/ReviewNotification/';

  constructor(private http: Http) {
    super(null);
  }


  public GetNotificationTemplate(auditType) {
    let service = 'GetNotificationTemplates';
    return this.http.get(this.RIABASE_URL + service + "?AuditType=" + auditType).pipe(
      map(response => response.json()));
  }


  public SetDefaultNotificationTemplate(notificationTemplateID, auditType) {
    let service = 'SetNotificationDefault';
    return this.http.post(this.RIABASE_URL + service, { auditType: auditType, notificationTemplateID: notificationTemplateID });
  }

  public SaveNotificationTemplate(objNotificationTemp: notification_template) {

    let service = 'SaveTemplate';
    return this.http.post(this.BASE_URL_API + service, objNotificationTemp);
  }

  public AddNewNotificationTemplate(objNotificationTemp: notification_template) {

    let service = 'AddNewTemplate';
    return this.http.post(this.BASE_URL_API + service, objNotificationTemp);
  }
  UpdateNotificationPackage(auditID:string,  changeList: EmailMessages[], auditType: number, typeofEdit: string):Observable<MsgResult> {
    let service = 'UpdateNotificationPackage';
//    return Observable.of({success:true,message:"Okay"});
//    return Observable.of({success:false,message:"Failed"});

    return this.http.post(this.BASE_URL_REVIEW_NOTIF_API + service, {auditID:auditID, changeList: changeList, auditType: auditType, typeofEdit: typeofEdit}).pipe(
      map( response => response.json()));
  }
  UpdateEmailBody(emailBody:string, auditID:string,  changeList: EmailMessages[], auditType: number, typeofEdit: string):Observable<MsgResult> {
    let service = 'BuildNotificationPackageWithEMailSave';
    return this.http.post(this.BASE_URL_REVIEW_NOTIF_API + service, {auditID:auditID, changeList:changeList, auditType: auditType, typeofEdit: typeofEdit, emailBody:emailBody}).pipe(
      map( response => response.json()));
  }
  UpdateEmailToAddress(auditID:string,  toEmailAddress:string, EmailAuditPackages: EmailAuditPackages[]):Observable<MsgResult>{
    let service = 'UpdateEmailToAddress';
    let notifactions = EmailAuditPackages.map(p => {
      return {
        notificationID:p.NotificationID,
        status:p.Status,
        notificationSource:p.NotificationSource,
        emailAddress:p.ToEMailAddress,
        deliveryFailed:p.DeliveryFailed
      };});
    return this.http.post(this.BASE_URL_REVIEW_NOTIF_API + service, {auditID:auditID, toEmailAddress:toEmailAddress, notifications:notifactions}).pipe(
      map( response => response.json()));
  }

  SendNotification(notificationID:string):Observable<MsgResult> {
    let service = 'SendNotification';
  //  return Observable.of({success:true,message:"Okay"});
  //return Observable.of({success:false,message:"Failed"});
    return this.http.post(this.BASE_URL_REVIEW_NOTIF_API + service,  JSON.stringify(notificationID), {headers:new Headers({ 'Content-Type': 'application/json' })}).pipe(
      map( response => response.json()));
  }

  GetEmailAuditPackages(auditId: string, auditType: number): Observable<FailedPassedEmailPackage> {
    let service = 'GetEmailAuditPackages';
    return this.http.get(this.BASE_URL_REVIEW_NOTIF_API + service + '?auditId=' + auditId + '&auditType=' + auditType).pipe(
      map(response => response.json()));
  }

  GetEmailMessage(notificationId: string): Observable<string> {
    let service = 'GetMessage';
    return this.http.get(this.BASE_URL_REVIEW_NOTIF_API + service + '?notificationId=' + notificationId).pipe(
      map(response => response.json()));
  }

  GetPropertyMessage(notificationMessageID: string): Observable<string> {
    let service = 'GetPropertyMessage';
    return this.http.get(this.BASE_URL_REVIEW_NOTIF_API + service + '?notificationMessageID=' + notificationMessageID).pipe(
      map(response => response.json()));
  }
}

@Injectable()
export class NotificationService extends RISDomainService {
  constructor(http: Http) { super(http); }
}
